/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React                      from 'react';
import PropTypes                  from 'prop-types';
import { StyledNavigationAnchor } from '../../atoms/StyledNavigationAnchor';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const NavigationAnchor = ({ exact, to, target, children, onAnchorClick }) => (
    <StyledNavigationAnchor onClick={onAnchorClick} exact={exact} to={to} target={target} rel={target === '_blank' ? 'noopener' : null}>{children}</StyledNavigationAnchor>
);

NavigationAnchor.propTypes = {
    children: PropTypes.node,
    onAnchorClick: PropTypes.func
};




// WEBPACK FOOTER //
// ./src/components/molecules/NavigationAnchor/index.js